import { DIALOGS_SET_ROLE_SELECTOR_VISIBILITY } from './types';

const defaultState = {
    roleSelectorVisible: undefined,
    impersonateRole: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case DIALOGS_SET_ROLE_SELECTOR_VISIBILITY:
            let roleSelectorVisible = action.data !== undefined ? action.data : !state.roleSelectorVisible;
            return {
                ...state,
                roleSelectorVisible: roleSelectorVisible,
                impersonateRole: roleSelectorVisible ? action.role : undefined,
                cancelImpersonate: roleSelectorVisible ? (action.cancelImpersonate === true ? true : undefined) : undefined
            };

        default:
            return state;
    }
}

export function setRoleSelectorVisibility(visible, impersonate = {}) {
    const { role, cancelImpersonate } = impersonate;
    return async function(dispatch) {
        dispatch({ type: DIALOGS_SET_ROLE_SELECTOR_VISIBILITY, data: visible, role, cancelImpersonate });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/dialogs.jsx